import React, { useEffect, useState } from "react";
import API from "../../api";
import RadioButton from "../../components/radioButton";

// redux
import { mapDispatchProps, mapStateToProps } from "../../store/store";
import { connect } from "react-redux";

import useInfiniteScroll from "../../hooks/useInfiniteScroll";
import Button from "../../components/button";
import GuideImage from "../../components/guideImage";
import { useLanguage } from '@languages/index';

function useForceUpdate() {
  const [value, setValue] = useState(0);
  return () => setValue((value) => value + 1);
}

const GuideIndex = (props: any) => {
  const language = useLanguage();   
  const languageTexts = { ...language.common, ...language.pages.settings };
  const forceUpdate = useForceUpdate();

  const [fetchedGuides, setFetchedGuides] = useState<any>([]);
  const [addedGuides, setAddedGuides] = useState<any>([]);
  const [combinedGuides, setCombinedGuides] = useState<any>([]);

  const [isFetchFinished, setIsFetchFinished] = useState(false);
  const [isContentEnded, setIsContentEnded] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);

  const [isFetching, setIsFetching] = useInfiniteScroll(() => {
    if (fetchedGuides.length) {
      fetchGuides();
    }
  });

  const menus = [
    {
      name: languageTexts.guide_menu_1,
      value: 1,
    },
    {
      name: languageTexts.guide_menu_2,
      value: 2,
    },
  ];

  const [selectedGuideTab, setSelectedGuideTab] = useState(menus[0]);

  const fileInput = React.useRef(null);

  const handleButtonClick = (e) => {
    fileInput.current.click();
  };

  const handleChange = (e) => {
    const image = e.target.files[0];

    API.Guide.uploadImage({
      brandToken: props.auth.token,
      image: image,
    })
      .then((response) => {
        const imageUrl = response.data.url;
        setAddedGuides([...addedGuides, imageUrl]);
      })
      .catch((error) => {})
      .finally(() => {
        forceUpdate();
      });
  };

  const submitGuides = () => {
    API.Guide.store({
      brandToken: props.auth.token,
      images: JSON.stringify(combinedGuides),
      isDefault: selectedGuideTab.name == menus[0].name ? 0 : 1,
    })
      .then((response) => {
        props.showModal({
          text: response.message,
          confirm: () => {
            setAddedGuides([]);
            fetchGuides(true);
          },
        });
      })
      .catch((error) => {
        props.showModal({ text: error.message });
      });
  };

  useEffect(() => {
    if (!fetchedGuides.length && !isContentEnded) {
      fetchGuides(true);
    }
  }, [fetchedGuides]);

  useEffect;

  useEffect(() => {
    fetchGuides(true);
  }, [selectedGuideTab]);

  useEffect(() => {
    let guides = [];

    fetchedGuides.forEach((image) => {
      guides.push(image);
    });

    addedGuides.forEach((image) => {
      guides.push({ url: image, descriptions: "" });
    });

    setCombinedGuides(guides);
  }, [fetchedGuides]);

  useEffect(() => {
    let guides = [];

    fetchedGuides.forEach((image) => {
      guides.push(image);
    });

    addedGuides.forEach((image) => {
      guides.push({ url: image, descriptions: "" });
    });

    setCombinedGuides(guides);
  }, [addedGuides]);

  const fetchGuides = (refresh = false) => {
    if (isContentEnded && !refresh) {
      return false;
    }

    const targetPage = refresh ? 1 : currentPage;

    API.Guide.index({
      ...{
        brandToken: props.auth.token,
        isDefault: selectedGuideTab.name == menus[0].name ? "true" : "false",
      },
    })
      .then((response) => {
        const fetchedGuides = response.data.guides;

        setFetchedGuides(fetchedGuides);

        setCurrentPage(targetPage + 1);
        setIsFetchFinished(true);
        setIsContentEnded(true);
        setIsFetching(false);
      })
      .catch((error) => {
        props.showModal({ text: error.message });
      });
  };

  const renderPageTitle = () => {
    return (
      <div className="container flex flex-col justify-center">
        <div className="p-5">
          <span className="prose prose-2xl font-bold text-black">
            {languageTexts.guideline}
          </span>
        </div>
      </div>
    );
  };

  const renderGuideDescription = () => {
    return (
      <div className="container flex flex-col justify-center px-5 pt-3">
        <span className="prose prose-md font-bold text-black">
          {languageTexts.guide_text_1}
        </span>
      </div>
    );
  };

  const renderGuideImages = () => {
    return (
      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 lg:grid-cols-7 py-6 gap-2">
        {renderGuideImage()}
        {renderGuideCreateButton()}
      </div>
    );
  };

  const renderGuideCreateButton = () => {
    if (selectedGuideTab.name == menus[0].name) {
      return <></>;
    }

    return (
      <div
        className="flex justify-center items-center cursor-pointer"
        style={{
          width: "90px",
          height: "90px",
          border: "1px solid #E8E8E8",
        }}
        onClick={handleButtonClick}
      >
        <div className="">+</div>
        <input
          type="file"
          ref={fileInput}
          onChange={handleChange}
          style={{ display: "none" }}
        />
      </div>
    );
  };

  const renderGuideImage = () => {
    let images = [];

    let isDefaultGuideImages = selectedGuideTab.name == menus[0].name;
    if (isDefaultGuideImages) {
      images = fetchedGuides;
    } else {
      fetchedGuides.forEach((image) => {
        images.push(image);
      });

      addedGuides.forEach((image) => {
        images.push({ url: image, descriptions: "" });
      });
    }

    return combinedGuides.map((guide, index) => {
      return (
        <GuideImage
          key={`guideImage${index}`}
          index={index}
          guide={guide}
          isDefault={isDefaultGuideImages}
          onDelete={(item) => {
            props.showModal({
              text: languageTexts.guide_text_2,
              cancel: () => {},
              confirm: () => {
                if (item.id) {
                  // delete existing image
                  API.Guide.delete({ id: guide.id })
                    .then((response) => {
                      setTimeout(() => {
                        props.showModal({
                          text: languageTexts.guide_text_3,
                          confirm: () => {
                            fetchGuides(true);
                          },
                        });
                      }, 400);
                    })
                    .catch((error) => {
                      setTimeout(() => {
                        props.showModal({
                          text: error.message,
                        });
                      }, 400);
                    });
                } else {
                  // delete recently added image
                  let copy = [...addedGuides];
                  copy = copy.filter((element) => element !== item.url);

                  setAddedGuides(copy);

                  props.showModal({
                    text: languageTexts.guide_text_3,
                    confirm: () => {
                      fetchGuides(true);
                    },
                  });
                }
              },
            });
          }}
          description={guide.description}
          onChangeText={(text) => {
            let copy = [...combinedGuides];

            copy[index]["description"] = text;

            setCombinedGuides(copy);
          }}
        />
      );
    });
  };

  const renderLoadingIndicator = () => {
    return isFetching && !isContentEnded ? (
      <div className="flex flex-row justify-center text-center my-5">
        <span className="prose prose-xl text-slate-400">
          {languageTexts.loading_1}
        </span>
      </div>
    ) : null;
  };

  return (
    <>
      <div className="px-5 xl:px-10 pb-10">
        {renderPageTitle()}
        {renderGuideDescription()}
        {renderGuideImages()}
        {renderLoadingIndicator()}
      </div>
    </>
  );
};

export default connect(mapStateToProps, mapDispatchProps)(GuideIndex);
